/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-await-in-loop */
import RootStateType from '@/store/types';
import { ActionContext, Module } from 'vuex';
import { applyTempAmount, eventLoopQueryNotify } from '@/api/tempAmount';
import { sleep } from '@/shared/utils/sleep';
// import { ubtSendError } from '@/shared/utils/ubt';
import {
  ApplyTempAmountResult,
  EventLoopNotifySceneEnum,
  NotifyPreCreditBusinessData,
  NotifyTempAmountBusinessData,
} from '@/api/tempAmount/types';
import generateMutations, {
  UPDATE_STATE_TYPE,
} from '@/store/generate-mutations';
import { RouterV2Enum } from '@/router/router-names';
import { HOME_ALL_VERSION_ROUTE_PATHS } from '@/router/utils';
import {
  RequestApplyParams, TempAmountSceneEnum, StateType, CheckTempStatusParams,
  GettersType,
  StoreActionType,
} from './types';
import store from '..';

/** 是否申请额度临额下发流程中 */
let isCreditApplying = false;
/** 轮询临额下发-任务状态 */
const pollingTempAmountTaskStatus: Record<string, number> = {};
/** 通用轮询变更通知-任务状态 */
const commonPollingNotifyStatus: Record<string, number> = {};

/** 通用轮询变更通知-最大轮询时间 */
const MAX_POLLING_SECONDS = 9;

const moduleStore: Module<StateType, RootStateType> = {
  namespaced: true,
  state: {
    tempAmountStatus: null,
    tempTimeout: 0,
    applyProductSuspendFeelTempAmount: false,
  },
  getters: {
    /** 是否已下发临时额度，当临额下发状态为false && 临额下发金额大于0 */
    isHasIssuedTempAmount(state: StateType) {
      const { tempAmountStatus } = state;

      return Boolean(tempAmountStatus
        && Number(tempAmountStatus.tempAvailableAmount) > 0
        && !tempAmountStatus.tempAmountApplying);
    },

    /** 是否当前已有：申请中、下发中的临时额度 */
    isHasApplyingTempAmount(state: StateType) {
      const { tempAmountStatus } = state;
      return Boolean(tempAmountStatus && tempAmountStatus.tempAmountApplying);
    },
  },
  actions: {
    /**
     * 检测用户当前状态-是否不存在临时额度，true: 不存在，false: 已存在
     * 若 临额下发中、临额已下发完成，返回 false
     * 若 服务接口异常，也返回 false
     */
    async checkNotExistTempAmount(
      context: ActionContext<StateType, RootStateType>,
      params?: CheckTempStatusParams,
    ): Promise<boolean> {
      try {
        const { frontEventLoopInnerRespList: dataList } = await eventLoopQueryNotify([
          EventLoopNotifySceneEnum.TEMP_AMOUNT,
        ]);

        for (let i = 0; i < dataList?.length; i++) {
          const data = dataList[i];
          const { scene, businessData } = data;

          if (scene === EventLoopNotifySceneEnum.TEMP_AMOUNT) {
            const tempAmountStatus = (businessData || {}) as NotifyTempAmountBusinessData;
            const { tempAmountApplying } = tempAmountStatus;

            /** 更新临时额度状态数据 */
            context.dispatch(UPDATE_STATE_TYPE, {
              tempAmountStatus,
            });

            /** 若临额正在下发中，则认为当前存在临额返回false */
            return Promise.resolve(!tempAmountApplying);
          }
        }

        return Promise.resolve(true);
      } catch (err) {
        return Promise.resolve(false);
      }
    },
    /** 轮询查询临时额度是否下发成功(默认轮询5次，每次间隔1秒，若还未返回“下发成功”则认为下发失败) */
    async pollingTempAmountIssued(
      context: ActionContext<StateType, RootStateType>,
      payload: {
        pollingCount?: number,
        targetHash?: string;
      },
    ): Promise<boolean> {
      /** 轮询剩余次数，默认5次 */
      let lastPollingCount = payload.pollingCount || 5;
      /** 轮询结果，临额是否下发成功 */
      let result = false;
      /** 记录当前页面hash，即route对象path: #/v2/apply-product?scene=amountButton */
      const currentPageHash = payload.targetHash || window.location.hash;
      const taskId = Date.now();

      /** 若当前页面hash已有轮询任务，则废弃历史任务的轮询，以当前任务为准 */
      pollingTempAmountTaskStatus[currentPageHash] = taskId;

      do {
        try {
          /** 若用户离开当前页面、有新的轮询任务，则终止本次任务失效 */
          if (!window.location.hash.includes(currentPageHash)
            || taskId < pollingTempAmountTaskStatus[currentPageHash]) {
            break;
          }

          lastPollingCount--;
          /** 轮询间隔1秒，首次也是1秒 */
          await sleep(1000);

          const { frontEventLoopInnerRespList: dataList } = await eventLoopQueryNotify([
            EventLoopNotifySceneEnum.TEMP_AMOUNT,
          ]);

          if (dataList?.length && taskId >= pollingTempAmountTaskStatus[currentPageHash]) {
            const tempAmountResult = dataList.find(
              (item) => item.scene === EventLoopNotifySceneEnum.TEMP_AMOUNT,
            );

            if (tempAmountResult) {
              const { businessData } = tempAmountResult;
              const tempAmountStatus = (businessData || {}) as NotifyTempAmountBusinessData;
              const { tempAvailableAmount, tempAmountApplying } = tempAmountStatus;

              /** 临时额度下发状态为false && 临额下发金额大于0，则中止轮询 */
              if (!tempAmountApplying && Number(tempAvailableAmount) > 0) {
                context.dispatch(UPDATE_STATE_TYPE, {
                  tempAmountStatus,
                });

                /** 更新首页额度 && 尝试展示临额弹窗 */
                store.dispatch('home/refreshHomePageByIssuedTempAmount');
                result = true;
              }

              /** 若临额已下发，则中止轮询 */
              if (tempAmountResult?.stopLoop || result) {
                break;
              }
            }
          }
        } catch (err) {
          // ubtSendError(err as Error);
        }
      } while (lastPollingCount > 0);

      pollingTempAmountTaskStatus[currentPageHash] = 0;

      return Promise.resolve(result);
    },
    /** 请求申请临额额度：额度不足500整数倍数，前端提交申请由服务端判断 */
    async requestApplyTempAmount(
      context: ActionContext<StateType, RootStateType>,
      params: RequestApplyParams,
    ): Promise<ApplyTempAmountResult> {
      try {
        const { tempAmountStatus } = context.state;
        const { tempAmountApplying } = tempAmountStatus || {};

        /** 若申请中状态，则不再申请，直接返回失败 */
        if (tempAmountApplying) {
          return Promise.resolve({});
        }

        const applyResult = await applyTempAmount(params?.scene);
        /** 若申请成功，则进入轮询流程：临额是否下发成功 */
        if (applyResult.tempAmountApplyResult) {
          /** 更新临时额度状态: 下发中 */
          context.dispatch(UPDATE_STATE_TYPE, {
            tempAmountStatus: {
              ...tempAmountStatus,
              scene: params?.scene,
              tempAmountApplying: true,
            },
          });
          context.dispatch('pollingTempAmountIssued', { pollingCount: applyResult.tempAmountArrivalTimeout });
        }

        return Promise.resolve(applyResult);
      } catch (err) {
        // ubtSendError(err as Error);
        return Promise.resolve({});
      }
    },

    /** 申请提额下发临额
     * 返回true/false, true表示可以继续执行后续逻辑，false表示后续逻辑需中断执行
     */
    async creditApplyTempAmount(
      context: ActionContext<StateType, RootStateType>,
    ): Promise<boolean> {
      let res = true;
      try {
        if (isCreditApplying) {
          return Promise.resolve(false);
        }
        if (await context.dispatch('checkNotExistTempAmount')) {
          isCreditApplying = true;
          const { tempAmountApplyResult, tempAmountArrivalTimeout = 4 } = (await context.dispatch(
            'requestApplyTempAmount',
            { scene: TempAmountSceneEnum.AMOUNT_BUTTON },
          )) as ApplyTempAmountResult;
          if (!tempAmountApplyResult) {
            isCreditApplying = false;
            return Promise.resolve(res);
          }
          let time = tempAmountArrivalTimeout;
          context.dispatch(UPDATE_STATE_TYPE, {
            tempTimeout: time,
          });
          /** 记录当前页面hash，即route对象path */
          const currentPageHash = window.location.hash;
          do {
            try {
              /** 轮询间隔1秒，首次也是1秒 */
              await sleep(1000);
              /** 若用户离开当前页面(首页、提现页)，则中断轮询任务 */
              if (currentPageHash !== window.location.hash) {
                res = false;
                break;
              }
              time--;
              context.dispatch(UPDATE_STATE_TYPE, {
                tempTimeout: time,
              });
              const hasIssuedTempAmount = (context.getters as GettersType).isHasIssuedTempAmount;
              if (hasIssuedTempAmount || !time) {
                res = !hasIssuedTempAmount;
                break;
              }
            } catch (err) {
              // ubtSendError(err as Error);
            }
          } while (time > 0);
        }
      } catch (err) {
        // ubtSendError(err as Error);
      }
      context.dispatch(UPDATE_STATE_TYPE, {
        tempTimeout: 0,
      });
      isCreditApplying = false;
      return Promise.resolve(res);
    },
    /** 更新临时额度下发状态的感知，比如提现页点击”提交“按钮之后 */
    async updateSuspendFeelTempAmount(
      context: ActionContext<StateType, RootStateType>,
      payload: {
        isApplyProductSuspendFeel?: boolean,
      },
    ): Promise<void> {
      await context.dispatch(UPDATE_STATE_TYPE, {
        applyProductSuspendFeelTempAmount: payload.isApplyProductSuspendFeel,
      });
    },
    /** 通用轮询消息，检查服务端是否有变更下发 */
    async commonPollingNotifyIssued(
      context: ActionContext<StateType, RootStateType>,
      payload: {
        loopSceneList: EventLoopNotifySceneEnum[],
      },
    ): Promise<void> {
      /** 记录当前页面hash，即route对象path: #/v2/apply-product?scene=amountButton */
      const currentPageHash = window.location.hash;
      const { state } = context;
      const { loopSceneList } = payload;
      const taskId = Date.now();
      /** 轮询已流逝的秒数 */
      let hasPassingSeconds = 0;

      /** 若当前页面hash已有轮询任务，则废弃历史任务的轮询，以当前任务为准 */
      commonPollingNotifyStatus[currentPageHash] = taskId;
      /** 待轮询的场景列表，每次轮询结束后，删除已出结果、已超时的场景 */
      const loopScenes = [...loopSceneList];

      do {
        try {
          /** 若用户离开当前页面、有新的轮询任务，则终止本次任务失效 */
          if (!window.location.hash.includes(currentPageHash)
            || taskId < commonPollingNotifyStatus[currentPageHash]) {
            break;
          }
          /** 当前页面是否是提现页 */
          const isApplyProductPage = currentPageHash.includes(RouterV2Enum.applyProduct);
          /** 当前页面是否是首页 */
          const isHomePage = HOME_ALL_VERSION_ROUTE_PATHS.some(
            (path) => currentPageHash.includes(path),
          );

          /** 若是”提现页“场景，”提交“按钮点击后，中止临额轮询任务 */
          if (isApplyProductPage && state.applyProductSuspendFeelTempAmount) {
            break;
          }

          /** 轮询间隔1秒，首次也是1秒 */
          await sleep(1000);
          /** 轮询计数 */
          hasPassingSeconds++;
          const {
            frontEventLoopInnerRespList: dataList,
          } = await eventLoopQueryNotify(loopScenes);

          /** 本次轮询任务有效的前提下，进行数据处理 */
          if (taskId >= commonPollingNotifyStatus[currentPageHash] && dataList?.length) {
            for (let i = 0; i < dataList?.length; i++) {
              const {
                scene, businessData, stopLoop, timeOut = 5,
              } = dataList[i];
              /** 是否应该中止当前场景的轮询 */
              const shouldStopThisSceneLoop = stopLoop || hasPassingSeconds >= timeOut;

              if (scene === EventLoopNotifySceneEnum.TEMP_AMOUNT) {
                const tempAmountStatus = (businessData || {}) as NotifyTempAmountBusinessData;
                const { tempAvailableAmount } = tempAmountStatus;

                /** 临额下发成功：stopLoop=true 且 金额大于0，才更新数据 */
                if (stopLoop && Number(tempAvailableAmount) > 0) {
                  if (isApplyProductPage) {
                    /** 若是提现页，未点击"提现"按钮，则更新临额数据 */
                    if (!state.applyProductSuspendFeelTempAmount) {
                      store.dispatch('applyProduct/updateZyAmountByIssuedTempAmount');
                    }
                  } else if (isHomePage) {
                    context.dispatch(UPDATE_STATE_TYPE, {
                      tempAmountStatus,
                    });

                    /** 若是首页，则无条件更新临额数据 */
                    store.dispatch('home/refreshHomePageByIssuedTempAmount');
                  }
                }
              } else if (scene === EventLoopNotifySceneEnum.PRE_CREDIT) {
                const { needRefresh } = (businessData || {}) as NotifyPreCreditBusinessData;

                if (stopLoop && needRefresh) {
                  await store.dispatch('home/refreshHomePageByUserCredit');
                }
              }

              if (shouldStopThisSceneLoop) {
                const position = loopScenes.indexOf(scene);
                /** 删除不用轮询该场景 */
                if (position > -1) {
                  loopScenes.splice(position, 1);
                }
              }
            }
          }

          /** 若无待轮询的场景，则中止轮询任务 */
          if (loopScenes.length === 0) {
            break;
          }
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error(err);
        }
        /** 前端兜底服务返回轮询次数异常 */
      } while (hasPassingSeconds < MAX_POLLING_SECONDS);

      commonPollingNotifyStatus[currentPageHash] = 0;

      return Promise.resolve();
    },
  },
};

export default generateMutations<StateType>(moduleStore);

export const generateDispatchActions = (): StoreActionType => ({
  creditApplyTempAmount:
    (): Promise<boolean> => store.dispatch('tempAmount/creditApplyTempAmount') as unknown as Promise<boolean>,
  checkNotExistTempAmount: (): Promise<boolean> => store.dispatch('tempAmount/checkNotExistTempAmount') as unknown as Promise<boolean>,
  requestApplyTempAmount:
    (
      params: RequestApplyParams,
    ): Promise<ApplyTempAmountResult> => store.dispatch('tempAmount/requestApplyTempAmount', params) as unknown as Promise<ApplyTempAmountResult>,
  commonPollingNotifyIssued:
    (payload: {
      loopSceneList: EventLoopNotifySceneEnum[],
    }): Promise<void> => store.dispatch('tempAmount/commonPollingNotifyIssued', payload) as unknown as Promise<void>,
});
